import React, { useEffect } from 'react'
import { Flex, Label } from 'shared/ui'

import LinkExistingGitHubIssueModal from './LinkExistingGitHubIssueModal'
import LinkNewGitHubIssueModal from './LinkNewGitHubIssueModal'

export default function LinkGitHubIssue({ doFetchGitHubInstalls }) {
  useEffect(() => {
    doFetchGitHubInstalls()
  }, [])
  return (
    <React.Fragment>
      <Label size="small">Link Conversation To Issue</Label>
      <Flex>
        <LinkExistingGitHubIssueModal />
        <LinkNewGitHubIssueModal />
      </Flex>
    </React.Fragment>
  )
}
